var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PartnerModalEdit',{ref:"PartnereditComponent",attrs:{"isModal":false},on:{"partnersaved":_vm.onsaved}})
}
var staticRenderFns = []

export { render, staticRenderFns }